'use strict';

module.exports = 0x39;